import React from 'react';
import { Redirect } from 'react-router-dom';
import { useAuthContext } from 'contexts/AuthContext';
import { LoadingScreen } from 'components';

export function LeadReferentGuard(props: { children: React.ReactNode }) {
  const { children } = props;
  const { userInfosIsLoading, isLeadReferent } = useAuthContext();

  if (userInfosIsLoading) {
    return <LoadingScreen />;
  }

  if (!isLeadReferent) {
    return <Redirect to="/errors/error-404" />;
  }

  return <>{children}</>;
}

/** Bloque les comptes « Partenaire Lead seul » (sans accès CEE). */
export function CEEAccessGuard(props: { children: React.ReactNode }) {
  const { children } = props;
  const { userInfosIsLoading, isLeadOnly } = useAuthContext();

  if (userInfosIsLoading) {
    return <LoadingScreen />;
  }

  if (isLeadOnly) {
    return <Redirect to="/errors/error-404" />;
  }

  return <>{children}</>;
}
